import Config from '../config';

const ID_TOKEN_KEY = 'GLSID';
const TOKEN_MAX_AGE = 60 * 60 * 24 * 1; // one day

const urlSearchParams = new URLSearchParams(location.search);
const queryToken = urlSearchParams.get('token');

class JwtService {
  sessionToken;

  constructor() {
    this.sessionToken = this.loadSessionToken();
    window.onfocus = () => this.checkSessionToken(this.loadSessionToken());
  }

  getSessionToken() {
    const token = this.loadSessionToken();
    if (token) {
      this.checkSessionToken(token);
      return token;
    }
    return null;
  }

  getApiKey() {
    if (queryToken) {
      return queryToken;
    }
    return sessionStorage.getItem(ID_TOKEN_KEY);
  }

  saveSessionToken(token) {
    this.sessionToken = token;
    document.cookie = `${ID_TOKEN_KEY}=${token}; max-age=${TOKEN_MAX_AGE}; domain=${Config.cookieDomain}; path=/; SameSite=None; Secure`;
  }

  saveApiKey(token) {
    sessionStorage.setItem(ID_TOKEN_KEY, token);
  }

  destroyApiKey() {
    sessionStorage.removeItem(ID_TOKEN_KEY);
  }

  destroySessionToken() {
    this.sessionToken = null;
    document.cookie = `${ID_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${Config.cookieDomain}; path=/; SameSite=None; Secure`;
  }

  destroyTokens() {
    this.destroySessionToken();
    this.destroyApiKey();
  }

  loadSessionToken() {
    const cookie = document.cookie.split(';').find((item) => item.trim().startsWith(ID_TOKEN_KEY));
    if (cookie) {
      const token = cookie.split('=')[1];
      return token;
    }
    return queryToken;
  }

  checkSessionToken(token) {
    if (this.sessionToken !== token) {
      this.destroyApiKey();
      location.reload();
    }
  }
}

const jwtService = new JwtService();
export default jwtService;
